(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("Immutable"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "Immutable"], factory);
	else if(typeof exports === 'object')
		exports["Scissors"] = factory(require("React"), require("Immutable"));
	else
		root["Scissors"] = factory(root["React"], root["Immutable"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 